import records from './records.fr.json';
import emailing from 'sellrm/emailing/frontend/i18n/fr.json';
import automations from 'sellrm/automations/frontend/i18n/fr.json';
import notes from 'sellrm/notes/frontend/i18n/fr.json';
import tasks from 'sellrm/tasks/frontend/i18n/fr.json';
import liveChat from 'sellrm/live_chat/frontend/i18n/fr.json';
import calendar from 'sellrm/calendar/frontend/i18n/fr.json';
import scoring from 'sellrm/scoring/frontend/i18n/fr.json';
import openers from 'sellrm/openers/frontend/i18n/fr.json';
import whatsappUnofficial from 'sellrm/whatsapp_unofficial/frontend/i18n/fr.json';
import branding from 'sellrm/branding/frontend/i18n/fr.json';
import agentAccess from 'sellrm/agent_access/frontend/i18n/fr.json';

// Features without a French file fall back to English through vue-i18n.
export default {
  ...records,
  ...emailing,
  ...automations,
  ...notes,
  ...tasks,
  ...liveChat,
  ...calendar,
  ...scoring,
  ...openers,
  ...whatsappUnofficial,
  ...branding,
  ...agentAccess,
};
